"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function JoinUsAtTheTable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="232991" id="ready-to-scale" className="dark bg-background text-foreground relative flex min-h-[70vh] items-center justify-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-background to-background opacity-80" />
        <div className="absolute left-1/2 top-1/2 h-[800px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/10 blur-[140px]" />
        <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto max-w-4xl px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h2 className="font-default text-foreground mb-8 text-5xl font-extrabold tracking-tighter uppercase sm:text-7xl md:text-9xl [text-shadow:_-1px_-1px_0_rgba(255,255,255,0.1),1px_-1px_0_rgba(255,255,255,0.1),-1px_1px_0_rgba(255,255,255,0.1),1px_1px_0_rgba(255,255,255,0.1)]">
          READY TO ASCEND?
        </h2>
        
        <p className="text-muted-foreground mx-auto mb-12 max-w-2xl font-sans text-lg font-medium sm:text-xl md:text-2xl tracking-tight">
          Partner with Benchmark Media Consulting to engineer your market dominance through data-driven strategy.
        </p>

        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-primary shadow-[0_0_20px_rgba(45,91,255,0.3)] h-16 rounded-sm border px-10 text-lg shadow-2xl transition-all duration-500 hover:scale-105 md:text-xl font-default uppercase tracking-wider">
          <Link to="/ConnectPage">
            Book Strategy Session
          </Link>
        </Button>
      </div>
    </section>;
}